import CheckmateSelect from '../CheckmateSelect';
import { IMultiSelectOption } from '../../../interfaces/ILookup';
import { IQueryFilterCriteriaSelectionValue } from '../../../interfaces/IQuery';
import { useDefenseCounselsLookup } from '../../../shared/react-query-hooks/useDefenseCounselsLookup';
import { useMemo } from 'react';

export interface ILocalCounselSelectorProps {
    disabled?: boolean;
    isSecondary?: boolean;
    multi?: boolean;
    onChange: (options: any) => void;
    value: IQueryFilterCriteriaSelectionValue[] | undefined;
    validationError?: string | undefined;
}

export function LocalCounselSelector(props: ILocalCounselSelectorProps) {
    const { data, isLoading } = useDefenseCounselsLookup();

    const availableOptions = useMemo(
        () =>
            data
                ?.filter((x) => (props.isSecondary && x.priority !== 1) || !props.isSecondary)
                .map(
                    (counsel) =>
                        ({
                            label: counsel.name,
                            value: counsel.guid,
                            guid: counsel.guid,
                        } as IMultiSelectOption)
                ),
        [props.isSecondary, data]
    );

    const selectedOptions = useMemo(
        () => availableOptions?.filter((opt) => props.value?.map((v) => v.guid).includes(opt.guid)),
        [props.value, availableOptions]
    );

    return (
        <>
            <CheckmateSelect
                isMulti={props.multi}
                options={availableOptions ?? []}
                isDisabled={props.disabled}
                value={selectedOptions}
                onChange={props.onChange}
                isLoading={isLoading}
            />
            <span className="text-danger">{props.validationError}</span>
        </>
    );
}
